// extracted by mini-css-extract-plugin
export var emailBlockLink = "_oa-0";